import { Sale_Type } from "gen/txn/models_pb"
import { useEnumFilter } from "shared-ts/hooks/useFilter"

import { useWebFilter, UseWebFilterProps } from "./useWebFilter"

const labelMap: Record<Sale_Type, string> = {
  [Sale_Type.UNDEFINED]: "Undefined",
  [Sale_Type.SALE]: "Sale",
  [Sale_Type.RETURN]: "Return",
}

export const useSaleTypeFilter = ({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<UseWebFilterProps<unknown>, "persistInUrl" | "initialSelectedOptions">
> = {}) =>
  useEnumFilter({
    key: "saleType",
    label: "Sale type",
    enumeration: Sale_Type,
    labelExtractor: (v: Sale_Type): string => {
      return labelMap[v]
    },
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })
